import { X } from 'lucide-react';
import type { GoalTaskBlock } from '@/entities/chat-message';

interface SkippedTaskLineProps {
  task: GoalTaskBlock;
}

export function SkippedTaskLine({ task }: SkippedTaskLineProps) {
  return (
    <span className="text-xs text-gray-500">
      <X className="inline h-3.5 w-3.5 align-[-0.15em]" /> Skipped{' '}
      <span className="font-medium text-gray-700">{task.data.title}</span>
    </span>
  );
}
